import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/arrow-down.svg")